/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDoctor } from 'app/shared/model/doctor.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IHospitalProcedure } from 'app/shared/model/hospital-procedure.model';
import { ITreatmentPlan } from 'app/shared/model/treatment-plan.model';
import { IPrescription } from 'app/shared/model/prescription.model';
import { IOpProcedureOrderItem } from 'app/shared/model/op-procedure-order-item.model';
import { ProcedureStatus } from 'app/shared/model/enumerations/procedure-status.model';
import { ProcedureStatusReason } from 'app/shared/model/enumerations/procedure-status-reason.model';
import { PrescriptionStatus } from 'app/shared/model/enumerations/prescription-status.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { ProcedureOutcome } from 'app/shared/model/enumerations/procedure-outcome.model';
import { BillOrigin } from 'app/shared/model/enumerations/bill-origin.model';

export interface IPatientProcedure {
  id?: string;
  plannedDate?: number;
  performedDate?: number | null;
  status?: keyof typeof ProcedureStatus | null;
  statusReason?: keyof typeof ProcedureStatusReason | null;
  preProcedureNotes?: string;
  postProcedureNotes?: string;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  approved?: boolean;
  approvedStatus?: keyof typeof PrescriptionStatus | null;
  addedByType?: keyof typeof AddedByType | null;
  addedById?: string | null;
  outcome?: keyof typeof ProcedureOutcome | null;
  patientType?: keyof typeof BillOrigin | null;
  surgeon?: IDoctor | null;
  anaesthesiologist?: IDoctor | null;
  patient?: IGlucoUser;
  procedure?: IHospitalProcedure;
  treatmentPlan?: ITreatmentPlan | null;
  prescription?: IPrescription | null;
  orderItem?: IOpProcedureOrderItem | null;
}

export const defaultValue: Readonly<IPatientProcedure> = {
  active: false,
  approved: false,
};
